export type Volume = {
  number: number
  dot: string
  group: string
  title: string
  subtitle: string
  tags: string[]
}

export const volumes: Volume[] = [
  {
    number: 1,
    dot: '#22C55E',
    group: 'Children Sub-10',
    title: 'Children Sub-10 Initial A',
    subtitle: 'First contact with the racquet',
    tags: ['Coordination', 'Mini-Tennis', 'Fun Games', 'Adapted Scoring'],
  },
  {
    number: 2,
    dot: '#22C55E',
    group: 'Children Sub-10',
    title: 'Children Sub-10 Initial B',
    subtitle: 'Direction & first scoring',
    tags: ['Cross-court', 'Adapted Rules', 'First Points'],
  },
  {
    number: 3,
    dot: '#EAB308',
    group: 'Children',
    title: 'Children Beginner — No Experience',
    subtitle: 'Building the first technical foundations',
    tags: ['Grip', 'Stance', 'Forehand', 'Backhand Basics'],
  },
  {
    number: 4,
    dot: '#EAB308',
    group: 'Children',
    title: 'Children Intermediate 1',
    subtitle: 'Consistency & first tactics',
    tags: ['Direction Control', 'Depth', 'First Pattern Play'],
  },
  {
    number: 5,
    dot: '#F97316',
    group: 'Children',
    title: 'Children Intermediate 2',
    subtitle: 'Patterns & doubles play',
    tags: ['CC–DTL Pattern', 'Serve Intent', 'Doubles Introduction'],
  },
  {
    number: 6,
    dot: '#F97316',
    group: 'Children',
    title: 'Children Advanced',
    subtitle: 'Competition preparation',
    tags: ['Net Game', 'Advanced Tactics', 'Tournament Readiness'],
  },
  {
    number: 7,
    dot: '#EF4444',
    group: 'Adults & Teens',
    title: 'Adults & Teens Beginner — No Experience',
    subtitle: 'Never held a racquet before',
    tags: ['First Rally', 'Basic Groundstrokes', 'First Points', 'Court Rules'],
  },
  {
    number: 8,
    dot: '#EF4444',
    group: 'Adults & Teens',
    title: 'Adults & Teens Intermediate 1',
    subtitle: 'Building consistency and direction',
    tags: ['Cross-court Control', 'Depth', 'T-Position Recovery'],
  },
  {
    number: 9,
    dot: '#A855F7',
    group: 'Adults & Teens',
    title: 'Adults & Teens Intermediate 2',
    subtitle: 'Topspin & tactical systems',
    tags: ['Heavy Topspin', 'Pattern Play', 'Mental Game Introduction'],
  },
  {
    number: 10,
    dot: '#A855F7',
    group: 'Adults & Teens',
    title: 'Adults & Teens Advanced',
    subtitle: 'High-performance club level',
    tags: ['Weapons', 'Kill Shot System', 'Serve + 1', 'Net Dominance'],
  },
  {
    number: 11,
    dot: '#D7F84A',
    group: 'Special Cases',
    title: 'Special Cases: Senior Players',
    subtitle: 'Adapted tennis for mature bodies',
    tags: ['Mobility', 'Balance', 'Low-Impact Drills', 'Enjoyment Focus'],
  },
  {
    number: 12,
    dot: '#D7F84A',
    group: 'Special Cases',
    title: 'Special Cases: Return from Injury',
    subtitle: 'Safe protocols for recovery',
    tags: ['Elbow', 'Knee', 'Shoulder', 'Back Return Plans'],
  },
]

export const volumeIncludes: string[] = [
  'Full session plans ready to use on court',
  'Professional drills with court diagrams',
  'Clear level-by-level progression',
  'Predefined session objectives',
  'Student evaluation sheets',
  'Adaptations for group classes',
  'Variations by skill level',
  'Optimised for mobile and A4 print',
]

export const coverage: string[] = [
  'Children Sub-10',
  'Children Beginner',
  'Children Intermediate',
  'Children Advanced',
  'Adults Beginner',
  'Adults Intermediate',
  'Adults Advanced',
  'Senior Players',
  'Injury Return',
]
